import React from 'react';

export default ({isSuper, isAgent, userData, children, isSeniorAgent}) => {
    // if is super user or agent user
    return isSuper || isAgent || isSeniorAgent ?
        React.cloneElement(children, {isSuper, isAgent, userData, isSeniorAgent})
        : (
        <div className='SuperAgent'>
            <h1>Not Authorized</h1>
            <p>Additional account permissions needed to view this page.</p>
        </div>
        )
}